import React, { useEffect, useState } from "react";
import { FaCreditCard, FaStar } from "react-icons/fa"; // Import FaStar for star icons
import axios from "axios";
import { Config } from "../../API/config";

interface Trainee {
    _id: string;
    name: string;
}

interface Payment {
    _id: string;
    trainerId: string;
    traineeId: Trainee;
    netProfit: number;
    status: string;
    rate: number; // Assuming rate is a number between 0 and 5
    price: number;
    createdAt: string;
    updatedAt: string;
}

const Revenues = () => {
    const [payments, setPayments] = useState<Payment[] | null>(null);
    const [loading, setLoading] = useState<boolean>(true);

    const fetchEnrollmentData = async () => {
        try {
            setLoading(true);
            let { data } = await axios.get(Config.getAllEnrollmentsForATrainer, {
                withCredentials: true,
            });
            if (data.statusCode === 200) {
                setPayments(data.data);
            }
        } catch (err) {
            console.error("Error fetching trainer data:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchEnrollmentData();
    }, []);

    // Function to render stars based on rating
    const renderStars = (rate: number) => {
        const maxStars = 5; // Maximum number of stars
        const filledStars = Math.round(rate); // Round the rate to the nearest integer
        return (
            <div className="flex justify-start">
                {[...Array(maxStars)].map((_, index) => (
                    <FaStar
                        key={index}
                        size={16}
                        className={index < filledStars ? "text-yellow-400" : "text-gray-300"}
                    />
                ))}
            </div>
        );
    };

    return (
        <div className="p-6 bg-white shadow-md rounded-lg" dir="rtl">
            <div className="flex flex-row items-center mb-5">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white shadow-md">
                    <FaCreditCard size={18} className="text-primary-200" />
                </div>
                <h2 className="mr-3 text-[20px] font-[400]">الايرادات</h2>
            </div>

            {loading ? (
                <p className="text-center text-gray-600">جاري التحميل...</p>
            ) : (
                <div className="overflow-x-auto">
                    <table className="w-full border-collapse border border-gray-200 text-right">
                        <thead className="bg-gray-100">
                            <tr>
                                <th className="p-3 border border-gray-200">الاسم</th>
                                <th className="p-3 border border-gray-200">التقييم</th>
                                <th className="p-3 border border-gray-200">صافي الربح</th>
                                <th className="p-3 border border-gray-200">التاريخ</th>
                                <th className="p-3 border border-gray-200">حالة الدفع</th>
                            </tr>
                        </thead>
                        <tbody>
                            {payments?.map((payment) => (
                                <tr key={payment._id} className="border border-gray-200">
                                    <td className="p-3">{payment.traineeId.name}</td>
                                    <td className="p-3">{renderStars(payment.rate)}</td> 
                                    <td className="p-3">{payment.netProfit} جنيه</td>
                                    <td className="p-3">{new Date(payment.createdAt).toLocaleDateString("ar-EG")}</td>
                                    <td className="p-3">
                                        <span
                                            className={`px-3 py-1 rounded-full text-sm font-semibold ${payment.status === "completed"
                                                ? "bg-green-200 text-white"
                                                : payment.status === "closed"
                                                    ? "bg-red-200 text-white"
                                                    : payment.status === "opened"
                                                        ? "bg-yellow-200 text-white"
                                                        : "bg-blue-200 text-blue-800" // Default for "pending"
                                                }`}
                                        >
                                            {payment.status === "completed"
                                                ? "مكتملة"
                                                : payment.status === "closed"
                                                    ? "مغلقة"
                                                    : payment.status === "opened"
                                                        ? "مفتوحة"
                                                        : "قيد الانتظار" // Default for "pending"
                                            }
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default Revenues;